import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import PageNotFoundText from 'components/atoms/PageNotFoundText'

import background from 'assets/images/404-background.png'

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'calc(100vh - 209px)',
    backgroundColor: theme.palette.background.light,
  },
  content: {
    width: '100%',
    height: '100%',
    maxWidth: 1440,
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  background: {
    top: 0,
    left: 0,
    zIndex: 0,
    width: '100%',
    height: '100%',
    display: 'block',
    position: 'absolute',
  },
})

const PageNotFound = ({ classes }) => (
  <div className={classes.root}>
    <div className={classes.content}>
      <img
        className={classes.background}
        src={background}
        alt="Chirp by Goodnature | 404 Banner"
      />
      <PageNotFoundText />
    </div>
  </div>
)

PageNotFound.propTypes = {
  classes: PropTypes.object,
}

export default withStyles(styles)(PageNotFound)



// WEBPACK FOOTER //
// ./src/containers/core/Dashboard/404.js